module.exports = __webpack_public_path__ + "static/img/about_banner.c942ace.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_banner.gif
// module id = ZbPE
// module chunks = 0